import React from 'react'

import { FiDownload } from 'react-icons/fi'

import { useDashboard } from '@/hooks'
import type { DashboardType } from '@/types/dashboard-types'

export interface ExportProps {
  onClose: () => void
}

const Export: React.FC<ExportProps> = ({ onClose }) => {
  const dashboardContext = useDashboard()
  const currentDashboard = dashboardContext.currentDashboard

  const handleExport = () => {
    // Create export object with dashboard data
    const exportData: DashboardType = {
      title: currentDashboard.title,
      slug: '', // Will be regenerated on import
      parameters: currentDashboard.parameters,
      insights: currentDashboard.insights,
      isDefault: false, // Never export as default
    }

    // Convert to JSON string
    const jsonString = JSON.stringify(exportData, null, 2)

    // Create a blob and download
    const blob = new Blob([jsonString], { type: 'application/json' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `${currentDashboard.title.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.cltrx`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)

    onClose()
  }

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 p-6">
        <div className="space-y-4 mb-4">
          <h3 className="text-lg font-medium">Export Dashboard</h3>
          <p className="text-gray-600">
            Export &quot;{currentDashboard.title}&quot; to a .cltrx file. You can import this file later to restore the
            dashboard.
          </p>
          <div className="flex flex-col gap-2">
            <div className="bg-base-200 p-4 rounded-md">
              <p className="text-sm font-medium mb-2">Dashboard Details:</p>
              <ul className="text-sm space-y-1 text-gray-600">
                <li>• Title: {currentDashboard.title}</li>
                <li>• Insights: {currentDashboard.insights.length}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-base-300 p-4 flex gap-2 justify-end">
        <button onClick={onClose} className="btn btn-ghost">
          Cancel
        </button>
        <button onClick={handleExport} className="btn btn-primary flex items-center gap-2">
          <FiDownload />
          Export Dashboard
        </button>
      </div>
    </div>
  )
}

export default Export
